import script from "./ResultView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultView.vue?vue&type=script&setup=true&lang=js"

import "./ResultView.vue?vue&type=style&index=0&id=0711368e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0711368e"]])

export default __exports__